var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button',{staticClass:"meldebutton",attrs:{"title":"Kommentar melden"},on:{"click":_vm.handle}},[_c('font-awesome-icon',{class:["fa-10" ,'flag'],attrs:{"icon":['fas', 'flag']}})],1),_c('text-dialog',{ref:"textDialogue"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }